import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const sendJobForm = createAsyncThunk("jobForm/sendJobForm", async (formValues, { rejectWithValue }) => {
  try {
    const formData = new FormData();

    for (const key in formValues) {
      if (formValues[key] !== undefined && formValues[key] !== null) {
        formData.append(key, formValues[key]);
      }
    }

    const response = await axios.post("https://milkys.bytesway.io/api/job-applicant", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("API Error Response: ", error.response?.data);
    return rejectWithValue(error.response?.data || "Unknown error");
  }
});

const JobFormSlice = createSlice({
  name: "jobForm",
  initialState: {
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetJobFormState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendJobForm.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(sendJobForm.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(sendJobForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Submission failed";
      });
  },
});

export const { resetJobFormState } = JobFormSlice.actions;
export default JobFormSlice.reducer;
